import React from 'react';
import goldBlackLogo from '../assets/Ayonk-goldandblack.webp';
import redLogo from '../assets/Ayonk-red.webp';
import red2Logo from '../assets/Ayonk-red2.webp';
import './Logo.css';

const Logo = ({ className }) => {
  return (
    <div className={`animated-logo-container ${className || ''}`}>
      <img src={goldBlackLogo} alt="Ayonk Logo" className="logo-part static" />
      <img src={redLogo} alt="Red part" className="logo-part red" />
      <img src={red2Logo} alt="Red 2 part" className="logo-part red2" />
    </div>
  );
};

export default Logo;
